import $apiIndex from "@/api/index";
import router from "@/router/index";
import { Message } from "element-ui";

export default {
  state: {
    userinfo: {}, //用户信息
  },
  mutations: {
    GET_USERINFO(state, value) {
      state.userinfo = value;
    },
  },
  actions: {
    //获取用户信息
    getuserInfo(context) {
      $apiIndex
        .GetUserInfo()
        .then((res) => {
          // console.log("router", res);
          context.commit("GET_USERINFO", res.data);
        })
        .catch((err) => {
          localStorage.clear();
          router.push({ path: "/login" });
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/message.js